export default __webpack_public_path__ + "43a7434fa357a069e2f46aac3f5e9e7d.svg";